import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import 'bootstrap/dist/css/bootstrap.min.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

window.addEventListener('load', () => {
  const version = '1.0.2'; // Ganti sesuai versi aplikasi Anda
  const savedVersion = localStorage.getItem('app_version');

  if (savedVersion !== version) {
    localStorage.setItem('app_version', version);
    window.location.reload(true); // Memuat ulang dari server, bukan cache
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
